import React, { useEffect, useMemo } from 'react';
import { Box, Inscription, PriceInput } from '@common-fe/common-fe';

import { PaymentMethodType } from '@/modules/employee/employee.types';
import { OverridablePropertiesDto } from '@/modules/employer/types';

import useReimbursementStore from './stores/useReimbursement.store';

interface Props {
  paymentMethodType: PaymentMethodType;
  overridableProperties?: OverridablePropertiesDto;
  disabled?: boolean;
}

const EmployeePaidFeeAmount: React.FC<Props> = ({ paymentMethodType, overridableProperties, disabled }) => {
  const {
    setPaymentEmployeeFee,
    paymentEmployeeFees,
  } = useReimbursementStore();
  const defaultValue = useMemo(() => {
    if (!overridableProperties?.allowedPaymentMethodConfigs?.length) return '';
    return overridableProperties.allowedPaymentMethodConfigs
      .find((item) => item.paymentMethodType === paymentMethodType)?.paymentEmployeeFee || '';
  }, [paymentMethodType, overridableProperties]);
  const value = useMemo(() => paymentEmployeeFees?.[paymentMethodType] || '0', [paymentEmployeeFees, paymentMethodType]);

  useEffect(() => {
    setPaymentEmployeeFee(defaultValue, paymentMethodType);
    return () => {
      setPaymentEmployeeFee('', paymentMethodType);
    };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [defaultValue]);

  return (
    <Box pad={{ vertical: 'spacing16' }} border={{ side: 'bottom', color: 'border1', size: 'small' }}>
      <Inscription weight="bold" lineHeight="20px" margin={{ bottom: 'spacing8' }}>
        Employee paid fee amount
      </Inscription>
      <PriceInput
        testId={paymentMethodType}
        id={paymentMethodType}
        name={paymentMethodType}
        placeholder="Enter $ amount"
        onChange={(value: string) => setPaymentEmployeeFee(value, paymentMethodType)}
        value={value}
        disabled={disabled}
      />
    </Box>
  );
};

export default EmployeePaidFeeAmount;
